import * as React from "react";

import { useDateFormatter } from "@/hooks/useDateFormatter";
import type { VersionInfo } from "../documentAuthoring.types";

interface Props {
  versions: VersionInfo[];
  /** `null` selects the head version. */
  selectedVersionId: string | null;
  headVersionId: string | null;
  disabled?: boolean;
  onSelect: (versionId: string | null) => void;
}

export const VersionPicker: React.FC<Props> = ({ versions, selectedVersionId, headVersionId, disabled, onSelect }) => {
  const { formatDateTime } = useDateFormatter();
  if (versions.length === 0) return null;
  const ordered = [...versions].sort((a, b) => b.version_no - a.version_no);
  return (
    <label className="flex items-center gap-2 text-xs text-gray-600">
      <span className="sr-only">Version</span>
      <select
        aria-label="Version"
        className="h-8 rounded-md border border-input bg-background px-2 text-xs"
        value={selectedVersionId ?? headVersionId ?? ""}
        disabled={disabled}
        onChange={event => onSelect(event.target.value === headVersionId ? null : event.target.value)}
      >
        {ordered.map(version => (
          <option key={version.id} value={version.id}>
            v{version.version_no}
            {version.id === headVersionId ? " (current)" : ""} · {version.created_by_name} ·{" "}
            {formatDateTime(version.created_at)}
            {version.status !== "ready" ? ` · ${version.status}` : ""}
          </option>
        ))}
      </select>
    </label>
  );
};
